import { GridTableBody, TableCellAttribute, UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { ColumnTypes } from 'src/app/views/grid-user-list/grid-table.enum';
import { DoctorLink } from '../../relation-request.interface';
import { doctorLinkSentRowData } from '../doctor-link-table-factory';

export class DoctorLinkSentTable {
  public buildTableData(items: DoctorLink[]): UserTableConstructorInfo {
    return {
      header: this.getTableHeader(),
      body: this.getTableBody(items),
      attribute: this.getManageCellAttribute(),
    };
  }

  private getTableHeader(): ColumnTypes[] {
    return [ColumnTypes.USER, ColumnTypes.SPECIALTIES, ColumnTypes.DATE, ColumnTypes.MANAGE];
  }

  private getManageCellAttribute(): TableCellAttribute {
    return { value_class_front: 'remove', key: 'remove' };
  }

  private getTableBody(items: DoctorLink[]): GridTableBody[] {
    return items.map(doctorLinkSentRowData);
  }
}
